import { render, staticRenderFns } from "./viewPicGenerica.vue?vue&type=template&id=25813554&scoped=true&"
import script from "./viewPicGenerica.vue?vue&type=script&lang=js&"
export * from "./viewPicGenerica.vue?vue&type=script&lang=js&"
import style0 from "./viewPicGenerica.vue?vue&type=style&index=0&id=25813554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25813554",
  null
  
)

export default component.exports